import { connect } from 'react-redux';

import Component from './Component';
import typeahead from '../actions/query-api/typeahead';
import tickerNames from '../actions/query-api/ticker-names';
import tickerNamesPartial from '../actions/query-api/ticker-names-partial';
import { downloadExampleTemplate } from '../actions/query-api/example-portfolio';

const mapStateToProps = (state, ownProps) => ({
  suggestions: state.fundSuggestions,
  loading: state.loadingFundSuggestions[ownProps.side],
  defaultPortfolio: state.defaultPortfolio,
  TEXT: state.complianceText,
  modelPortfolios: state.entry.modelPortfolios,
  uniqueModelFamilies: state.entry.uniqueModelFamilies,
  selectedModel: state.entry[ownProps.side].selectedModel,
  selectedModelFamily: state.entry[ownProps.side].selectedModelFamily,
  compareMode: state.entry.compareMode,
  showModelInput: state.entry[ownProps.side].showModelInput,
  features: state.features,
  personalStrategies: state.entry.personalStrategies,
  selectedPersonalStrategy: state.entry[ownProps.side].selectedPersonalStrategy,
  isoCode: state.isoCode,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  downloadExampleTemplate(){
    dispatch(downloadExampleTemplate);
  },
  onSelectQuery(tickers){
    dispatch(tickerNamesPartial(tickers))
  },
  querySuggestions(query) {
    dispatch(typeahead(query));
  },
  queryTickers(tickers, name){
  	dispatch(tickerNames(tickers, name))
  },
  handleUploadError: (message, callback) => dispatch({
    type: 'DIALOG',
    message,
    buttons: [
      { label: 'Cancel' },
      { label: 'Try again', callback },
    ],
  }),
  loadPortfolio: portfolio => dispatch({ type: 'LOAD_PORTFOLIO', portfolio }),
  setSelectedModel: model => dispatch({ type: 'SET_SELECTED_MODEL', model, side: ownProps.side }),
  setSelectedModelFamily: modelFamily => dispatch({ type: 'SET_SELECTED_MODEL_FAMILY', modelFamily, side: ownProps.side }),
  setShowModelInput: show => dispatch({ type: 'SET_SHOW_MODEL_INPUT', show, side: ownProps.side }),
  setCompareMode(currentMode){
    dispatch({ type: 'SET_COMPARE_MODE_MODELS', currentMode, side: ownProps.side });
  },
  setSelectedPersonalStrategy: personalStrategyId => dispatch({ type: 'SET_SELECTED_PERSONAL_STRATEGY', personalStrategyId, side: ownProps.side }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./src/FundInput/index.js